import { render } from "./ZaikomeisaiDistributor.vue?vue&type=template&id=7889d1ee"
import script from "./ZaikomeisaiDistributor.vue?vue&type=script&lang=js"
export * from "./ZaikomeisaiDistributor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__